// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"f5f476a3","990":"05e11028"}[chunkId] + ".chunk.js";
};